import { render, staticRenderFns } from "./SmartSearchbarClassifiedSuggestion.vue?vue&type=template&id=b309c544&scoped=true&"
import script from "./SmartSearchbarClassifiedSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SmartSearchbarClassifiedSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b309c544",
  null
  
)

export default component.exports